import {
  FETCH_CONTENT_LIST,
  FETCH_CONTENT_DETAILS,
  SAVE_CONTENT_DETAILS,
  PUBLISH_CONTENT_DETAILS,
} from './cms.actions';
import { SUCCESS, FAILURE, REQUEST } from 'utils/actionGenerator';

const defaultState = {
  contentList: null,
  contentDetails: null,
  updatedSlug: null,
  publishedState: false,
};

export default function (state = defaultState, action: any) {
  switch (action?.type) {
    case FETCH_CONTENT_LIST[REQUEST]: {
      return {
        ...state,
        contentList: null,
      };
    }
    case FETCH_CONTENT_LIST[SUCCESS]: {
      return { ...state, contentList: action.response.data };
    }

    case FETCH_CONTENT_LIST[FAILURE]: {
      return {
        ...state,

        contentList: null,
      };
    }
    case FETCH_CONTENT_DETAILS[REQUEST]: {
      return { ...state, contentDetails: null };
    }

    case FETCH_CONTENT_DETAILS[SUCCESS]: {
      return { ...state, contentDetails: action.response.data };
    }
    case FETCH_CONTENT_DETAILS[FAILURE]: {
      return { ...state, contentDetails: null };
    }

    case SAVE_CONTENT_DETAILS[REQUEST]: {
      return { ...state, updatedSlug: null };
    }
    case SAVE_CONTENT_DETAILS[SUCCESS]: {
      return { ...state, updatedSlug: action.response.data };
    }
    case SAVE_CONTENT_DETAILS[FAILURE]: {
      return { ...state, updatedSlug: null };
    }
    case PUBLISH_CONTENT_DETAILS[REQUEST]: {
      return { ...state, publishedState: false };
    }
    case PUBLISH_CONTENT_DETAILS[SUCCESS]: {
      return { ...state, publishedState: true };
    }
    case PUBLISH_CONTENT_DETAILS[FAILURE]: {
      return { ...state, publishedState: false };
    }
    default:
      return { ...state };
  }
}
